export default function rotateDeg (i){
    return - (this.rotateDeg(i) + this.unskewDeg);
}